import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jiraAppLabelSpork: {
		id: 'project-create-importer-upload-flow.common.constants.tools.jira-app-label-spork',
		defaultMessage: '(software project)',
		description: 'Label for Jira software project app import option',
	},
	jiraBusinessAppLabelNonFinal: {
		id: 'project-create-importer-upload-flow.common.constants.tools.jira-business-app-label-non-final',
		defaultMessage: '(business project)',
		description:
			'This text is shown as a sub-title on the button which gives the user an option to import from a Jira business project, to a Jira software project.',
	},
});
